import { FieldType } from '@wix/wix-data-schema-types'
import {
  SELECTION_TAGS_ROLE,
  SELECTION_TAGS_OPTIONS_ROLE,
  USER_INPUT_FILTER_SELECTION_TAGS_ROLE,
  GenericRole,
} from '@wix/wix-data-client-common-standalone'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

const { stringArray, text, number, reference } = FieldType

export default (): DataBindingComponentModel => ({
  componentName: 'Element_Name_Selection_Tags_List',
  isConnectGfppEnabled: true,
  supportsDefaultSelectedDataset: true,
  panel: {
    height: 436,
    title: 'Connect_Panel_Title_Selection_Tags',
    helpId: '28dd3873-0bae-4033-8e9e-f2f6af69e243',
    chooseScreenHelpId: '349d1985-d389-496b-bd58-98b98453cfa1',
    submitContentHelpId: 'b9c58394-0f63-4d26-bb3a-41fa6ce1eaac',
    userInputFilterHelpId: 'f7560b6c-21e5-489d-acc2-c0dc8d09f282',
  },
  sections: [
    {
      role: SELECTION_TAGS_ROLE,
      genericRole: GenericRole.INPUT_VALUE,
      bindings: [
        {
          title: 'Connect_Panel_Connect_Selection_Tags_Tag_Value',
          prop: 'value',
          supportedFieldTypes: [stringArray],
          defaultFieldType: stringArray,
          isInputProperty: true,
          emptyValue: [],
        },
      ],
    },
    {
      role: SELECTION_TAGS_OPTIONS_ROLE,
      genericRole: GenericRole.INPUT_VALUE_OPTIONS,
      bindings: [
        {
          title: 'Connect_Panel_Connect_List_Options_Values_Label',
          prop: 'options',
          supportedFieldTypes: [text, number],
          defaultFieldType: text,
          requiresPrimaryConnection: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            mainAction1: {
              actionId:
                'selection_tags_options_live_preview_gfpp_desktop_main_action',
              label:
                'Selection_Tags_Options_Live_Preview_GFPP_Desktop_Main_Action',
            },
          },
        },
      },
      manageContentPanel: {
        isElementNamePlural: true,
      },
    },
    {
      role: USER_INPUT_FILTER_SELECTION_TAGS_ROLE,
      isUserInputFilter: true,
      bindings: [
        {
          prop: 'value',
          supportedFieldTypes: [text, number, stringArray, reference],
          defaultFieldType: text,
          requiresPrimaryConnection: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            mainAction1: {
              actionId:
                'user_input_filters_live_preview_gfpp_desktop_main_action',
              label: 'User_Input_Filters_Live_Preview_GFPP_Desktop_Main_Action',
            },
          },
        },
        panel: {
          settings: {
            controls: {
              required: {
                hidden: true,
              },
            },
          },
        },
      },
      manageContentPanel: {
        isElementNamePlural: true,
      },
    },
  ],
  compactErrorPanel: true,
})
